<template>
    <div>
        <Loader ref="Loader"></Loader>
        <ErrorModal ref="ErrorModal"></ErrorModal>
        <SuccessModal ref="SuccessModal"></SuccessModal>
        <YesNoModal ref="YesNoModal"></YesNoModal>
        <v-flex xs12>
            <v-card>
                <v-toolbar color="secondary" dark dense>
                    <v-toolbar-title>Ops-Manager Class Types</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-layout fill-height row mr-1 ml-1 mt-2>
                    <v-flex xs12 sm12 md12 lg12 xl12>
                        <v-card>
                            <v-btn v-if="HasAccess('CLASS_MANAGEMENT', 'CREATE')" style="float:right;"
                                color="success --darken-2" @click="AddClassTypeDialog = true">
                                <v-icon>add</v-icon>Add Class
                            </v-btn>
                            <v-data-table :headers="headers" :items="ClassTypes" :search="search"
                                :rows-per-page-items="[25,50,75,100]">
                                <template slot="no-data">There are no records</template>
                                <template slot="no-results">No matching records found</template>
                                <template slot="headerCell" slot-scope="{ header }">
                                    <span class="subheading font-weight-light text-success text--darken-3"
                                        v-text="header.text" />
                                </template>
                                <template v-slot:items="props">
                                    <!-- <td>{{ item.Name }}</td> -->
                                    <td>{{ props.index+1 }}</td>
                                    <td v-if="editing == true && props.item.ID == editingID">
                                        <v-text-field v-model="props.item.Name"></v-text-field>
                                    </td>
                                    <td v-else>{{ props.item.Name }}</td>
                                    <!-- <td>{{ props.item.ClassTypeName }}</td> -->
                                    <td v-if="editing == true && props.item.ID == editingID">
                                        <v-select v-model="props.item.Type" :items="classTypeItems" item-text="Name" item-value="ID"></v-select>
                                    </td>
                                    <td v-else>{{ props.item.ClassTypeName }}</td>
                                    <td v-if="editing == true && props.item.ID == editingID">
                                        <v-text-field type="number" v-model="props.item.Count"></v-text-field>
                                    </td>
                                    <td v-else>{{ props.item.Count }}</td>
                                    <td style="float:right;">
                                        <v-btn small color="success"
                                            v-if="editing == true && props.item.ID == editingID"
                                            @click="modifyItem(props.item)">
                                            <v-icon>save</v-icon>
                                        </v-btn>
                                        <v-menu dense bottom left>
                                            <v-btn small slot="activator" color="primary" dark>
                                                <v-icon>settings</v-icon>
                                            </v-btn>

                                            <div
                                                v-if="HasAccess('CLASS_MANAGEMENT', 'MODIFY') || HasAccess('CLASS_MANAGEMENT', 'DELETE')">
                                                <v-list dense v-for="(action, index) in actionItems" :key="index">
                                                    <v-list-tile @click="PerformOperation(action, props.item)"
                                                        v-if="action.access == true">
                                                        <v-list-tile-action>
                                                            <v-icon color="primary darken-2">{{ action.icon }}</v-icon>
                                                        </v-list-tile-action>
                                                        <v-list-tile-title>{{ action.title }}</v-list-tile-title>
                                                    </v-list-tile>
                                                </v-list>
                                            </div>
                                            <div v-else>
                                                <v-list dense>
                                                    <v-list-tile>
                                                        <v-list-tile-title>
                                                            You have no options
                                                            available
                                                        </v-list-tile-title>
                                                    </v-list-tile>
                                                </v-list>
                                            </div>
                                        </v-menu>
                                    </td>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-card>
            <!-- CLASS TYPE DIALOG FOR CREATE -->
            <v-dialog v-model="AddClassTypeDialog" width="600px" offset-x persistent>
                <v-form ref="classTypeDialog">
                    <v-card>
                        <v-toolbar color="secondary" dark>
                            <v-toolbar-title>Create New Class</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="AddClassTypeDialog = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-layout row wrap ma-4>
                            <v-flex xs12 sm12 md12 lg12 xl12>
                                <v-text-field v-model="form.Name" label="Class Name">
                                </v-text-field>
                                <v-layout row wrap>
                                    <v-flex xs8 mr-2>
                                        <v-select v-model="form.Type" :items="classTypeItems" label="Class Type"
                                            item-text="Name" item-value="ID"></v-select>
                                    </v-flex>
                                    <v-flex xs3>
                                        <v-text-field v-model="count" type="number" label="Frequency"></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <v-card-actions>
                            <v-layout justify-end>
                                <v-btn color="primary" @click="CreateClass()" :disabled="form.Name == null">
                                    Create
                                </v-btn>
                                <v-btn flat @click="AddClassTypeDialog = false">
                                    Cancel
                                </v-btn>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-flex>
    </div>
</template>

<script>
    export default {
        data() {
            let self = this;
            return {
                editing: false,
                editingID: 0,
                AddClassTypeDialog: false,
                count: 0,
                ClassTypes: [],
                actionItems: [{
                        type: "modify",
                        title: "Modify",
                        access: self.HasAccess("CLASS_MANAGEMENT", "MODIFY"),
                        icon: "edit"
                    },
                    {
                        type: "delete",
                        title: "Delete",
                        access: self.HasAccess("CLASS_MANAGEMENT", "DELETE"),
                        icon: "delete"
                    }
                ],
                headers: [{

                    },
                    {
                        sortable: true,
                        text: "Name",
                        value: "Name"
                    },
                    {
                        sortable: true,
                        text: "Class Type",
                        value: "ClassTypeName"
                    },
                    {
                        sortable: true,
                        text: "Frequency",
                        value: "Count"
                    },
                    {
                        sortable: false,
                        align: "right",
                        text: "Actions"
                    }
                ],
                form: {
                    Name: null,
                    Type: 0,
                    Count: 0
                },
                classTypeItems: [{
                        ID: 1,
                        Name: "Daily"
                    },
                    {
                        ID: 2,
                        Name: "Weekly"
                    },
                    {
                        ID: 3,
                        Name: "Monthly"
                    }
                ],
            }
        },
        props: {
            search: String
        },
        mounted() {
            let self = this;
            self.getClassTypes();
        },
        methods: {
            getClassTypes() {
                let self = this;
                self.get('ClassType').then(r => {
                    r.data.forEach(classType => {
                        if (classType.Type == 1) {
                            classType.ClassTypeName = "Daily";
                        } else if (classType.Type == 2) {
                            classType.ClassTypeName = "Weekly";
                        } else {
                            classType.ClassTypeName = "Monthly";
                        }
                        self.ClassTypes = r.data;
                        console.log("CLASS TYPES", self.ClassTypes)
                    })
                })
            },
            CreateClass() {
                let self = this;
                self.form.Count = parseInt(self.count);
                console.log("REQUEST TO SUBMIT", self.form);
                self.post('ClassType', self.form).then(r => {
                    self.$refs.SuccessModal.show(); // success modal
                    self.$refs.SuccessModal.setText("Class has been created!");
                    setTimeout(function () {
                        self.getClassTypes();
                        self.AddClassTypeDialog = false;
                        self.form = {}
                        self.$refs.SuccessModal.hide();
                    }, 1000);
                })
            },
            PerformOperation(action, item) {
                let self = this;
                switch (action.type.toUpperCase()) {
                    case "MODIFY": {
                        //self.modifyItem(item);
                        self.editing = true;
                        self.editingID = item.ID;
                    }
                    break;
                case "DELETE": {
                    self.deleteItem(item);
                }
                break;
                }
            },
            modifyItem(item) {
                let self = this;
                console.log("modify item", item)
                console.log("EDIT ITEM", item);
                self.put(`ClassType?id=${item.ID}`, item).then(r => {
                    self.$refs.SuccessModal.show(); // success modal
                    self.$refs.SuccessModal.setText("Class has been edited!");
                    setTimeout(function () {
                        self.getClassTypes();
                        self.editing = false;
                        self.editingID = 0;
                        self.$refs.SuccessModal.hide();
                    }, 1000);
                })
            },
            deleteItem(item) {
                let self = this;

                item.IsDeleted = true;
                console.log("CLASS ITEM TO DELETE", item)
                self.$refs.YesNoModal.show(
                    "Are you sure you want to delete this class?",
                    function (yes) {
                        if (yes == true) {
                            self.$refs.Loader.show(true);
                            self.$refs.Loader.setText("Deleting class...");
                            self.put(`ClassType?id=${item.ID}`, item)
                                .then(result => {
                                    self.$refs.Loader.hide();
                                    if (result.data == true) {
                                        var index = self.ClassTypes.indexOf(item);
                                        if (index > -1) {
                                            self.ClassTypes.splice(index, 1);
                                        }
                                    }
                                })
                                .catch(error => {
                                    self.$refs.Loader.hide();
                                    self.$refs.ErrorModal.show();
                                    self.$refs.ErrorModal.setText(error.toString());
                                });
                        }
                    }
                );
            }
        }
    }
</script>

<style>

</style>